import React from "react";
import { makeStyles } from "@material-ui/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  progressContainer: {
    display: "none",
    padding: "8px 16px",
    "@media(max-width: 1024px)": {
      display: "block",
    },
  },
  noBookingsStroke: {
    color: theme.app.background[0],
  },
  successStroke: {
    backgroundColor: theme.app.successColor,
    color: theme.app.successColor,
  },
  warningStroke: {
    backgroundColor: theme.app.warningColor,
    color: theme.app.warningColor,
  },
  dangerStroke: {
    backgroundColor: theme.app.dangerColor,
    color: theme.app.dangerColor,
  },
  circularProgressContainer: {
    width: "55px",
    height: "55px",
    position: "relative",
  },
  progress: {
    color: theme.app.progressTrailColor,
  },
  progressTrail: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "50px",
  },
  progressValue: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "50px",
  },
  progressText: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: theme.app.labelColor,
    fontWeight: 500,
  },
  progressTextFull: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: theme.app.dangerColor,
    fontWeight: 500,
  },
}));

const Progress = (props) => {
  const { language } = useSelector((state) => ({
    language: state.language,
  }));
  const { booked } = props;
  const classes = useStyles();
  const notEmpty = booked > 0;
  const notFull = booked < 100;
  const getStroke = (booked) => {
    if (booked < 1) {
      return classes.successStroke;
    }
    if (booked < 76) {
      return classes.successStroke;
    }
    if (booked < 90) {
      return classes.warningStroke;
    }
    return classes.dangerStroke;
  };

  return (
    <div className={classes.circularProgressContainer}>
      {notFull && (
        <>
          <div className={classes.progressTrail}>
            <CircularProgress
              aria-hidden="true"
              size={50}
              variant="determinate"
              value={100}
              className={classes.progress}
            />
          </div>

          <div className={classes.progressValue}>
            <CircularProgress
              aria-label={`${booked}% ${language.spotsBooked}`}
              size={50}
              classes={{
                circle: getStroke(booked),
              }}
              variant="determinate"
              value={booked}
            />
          </div>
        </>
      )}
      {notEmpty && (
        <Typography
          className={notFull ? classes.progressText : classes.progressTextFull}
        >
          {notFull ? `${booked}%` : `FULLT`}
        </Typography>
      )}
    </div>
  );
};

export default Progress;
